// =============================================================================
// STORE ZUSTAND - État du panneau Graphiques
// =============================================================================

import { create } from 'zustand';

type TabId = 'evolution' | 'comparaison' | 'repartition';

interface GraphiquesStore {
  isOpen: boolean;
  activeTab: TabId;
  openPanel: () => void;
  closePanel: () => void;
  setActiveTab: (tab: TabId) => void;
  togglePanel: () => void;
}

export const useGraphiquesStore = create<GraphiquesStore>((set) => ({
  isOpen: false,
  activeTab: 'evolution',

  openPanel: () => set({ isOpen: true }),

  closePanel: () => set({ isOpen: false }),

  setActiveTab: (tab) => set({ activeTab: tab }),

  togglePanel: () => set((state) => ({ isOpen: !state.isOpen })),
}));
